import { ReactNode, useState, useRef } from "react";
import styles from "./fade-animation-wrapper.module.css";

interface FadeAnimationWrapperProps {
  children: (triggerClose: (callback: () => void) => void, fadeClassName?: string) => ReactNode;
}

export default function FadeAnimationWrapper({ children }: FadeAnimationWrapperProps) {
  const [isClosing, setIsClosing] = useState(false);
  const closeCallbackRef = useRef<(() => void) | null>(null);

  const handleAnimationEnd = (e: React.AnimationEvent) => {
    if (e.animationName.includes("fadeOut") && closeCallbackRef.current) {
      closeCallbackRef.current();
      closeCallbackRef.current = null;
    }
  };

  const triggerClose = (callback: () => void) => {
    closeCallbackRef.current = callback;
    setIsClosing(true);
  };

  const wrapperClassName = `${styles.wrapper} ${isClosing ? styles.fadeOut : styles.fadeIn}`;
  const animationClassName = isClosing ? styles.fadeOut : styles.fadeIn;

  return (
    <div className={wrapperClassName} onAnimationEnd={handleAnimationEnd}>
      {children(triggerClose, animationClassName)}
    </div>
  );
}
